import { LaneInput } from '@kinetic-ui/data-layer';
import { Coordinates } from '../types';
import { SetState, RecursivePartial } from 'types';
import { DragElement } from 'components/maps';

type LaneDragPointsProps = {
  editingLane?: RecursivePartial<LaneInput>;
  setEditingLane: SetState<RecursivePartial<LaneInput | undefined>>;
};

export function LaneDragPoints({ editingLane, setEditingLane }: LaneDragPointsProps) {
  const onUpdateMapSelectedLanePoint = (lngLat: [number, number], index: number) => {
    const newCoordinates = editingLane?.geometry.coordinates.map(
      (coords: Coordinates, coordIndex: number) => {
        if (index === coordIndex) {
          return lngLat;
        }
        return coords;
      }
    );
    setEditingLane((prev) => ({
      ...prev,
      geometry: { type: 'LineString', coordinates: newCoordinates },
    }));
  };

  const onDeleteMapSelectedLanePoint = (index: number) => {
    const newCoordinates = editingLane?.geometry.coordinates.filter(
      (_c: Coordinates, coordIndex: number) => {
        return index !== coordIndex;
      }
    );
    setEditingLane((prev) => ({
      ...prev,
      geometry: { type: 'LineString', coordinates: newCoordinates },
    }));
  };

  return (
    <g>
      {editingLane?.geometry?.coordinates.map((point: [number, number], pointIndex: number) => (
        <DragElement
          key={pointIndex}
          centerLatLng={[...point]}
          setCenterLatLng={(newCoordinates: [number, number]) => {
            // if newCoordinates is not null, move this point
            if (newCoordinates) {
              onUpdateMapSelectedLanePoint([...newCoordinates], pointIndex);
              // if newCoordinates is null, delete the point
            } else {
              onDeleteMapSelectedLanePoint(pointIndex);
            }
          }}
          deleteable
          showMoveCursor
        />
      ))}
    </g>
  );
}
